<div class="dialog-component">
  <div class="container">
    <div class="dialog-body">
      <p class="description">Allowed tools to use:</p>
      <div class="tool-selection-container">
        <div class="tool-selection">
          <mat-selection-list
            [ngModel]="selectedItems()"
            (ngModelChange)="selectedItems.set($event); newItemEvent.emit($event)"
            #selectionList>
            @for (item of items(); track item) {
              <mat-list-option [value]="item.id" (click)="changeSelectedTools()"
                >{{ item.name }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      </div>
    </div>
  </div>
</div>
